export default "__VITE_ASSET__nFL5X3YW__"